{
  "_comment": "[CI-LOCKED] محتوى هذا الملف مؤمن. نرحب بالمساهمات، ولكن التحقق من صحة التغيير قد يتأخر.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "قابل الروبوت $1:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "العامل",
  "ACTIVITY_YOU_SAID_ALT": "لقد قلت:",
  "ACTIVITY_BOT_ATTACHED_ALT": "قام الروبوت بإرفاق:",
  "ACTIVITY_CODE_ALT": "عينة التعليمات البرمجية: $1",
  "ACTIVITY_CONTENT_CAUTION": "قد يكون المحتوى الذي يتم إنشاؤه بواسطة الذكاء الاصطناعي غير صحيح",
  "ACTIVITY_CODE_CAUTION": "تعليمات برمجية تم إنشاؤها بواسطة الذكاء الاصطناعي. يرجى مراجعتها واستخدامها بعناية",
  "ACTIVITY_ERROR_BOX_TITLE": "رسالة الخطأ",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "انقر للتفاعل.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "الرسالة تفاعلية.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "ارتباط واحد أو أكثر في الرسالة.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "فشل الإرسال.",
  "ACTIVITY_YOU_ATTACHED_ALT": "لقد قمت بإرفاق:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "‏‏مرفق واحد.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 مرفق (مرفقات).",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 مرفق (مرفقات).",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 مرفق (مرفقات).",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 مرفق (مرفقات).",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "فشل الإرسال. [إعادة المحاولة][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "جارٍ الإرسال",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "تم إرسالها عند الساعة $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "الآن",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "قبل ساعة",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "قبل دقيقة",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "اليوم",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "الأمس",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "خطأ في تحليل البطاقة الموائمة",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "خطأ في عرض البطاقة الموائمة",
  "ATTACHMENT_AUDIO": "مقطع صوتي.",
  "ATTACHMENT_CARD": "بطاقة: $1 $2 $3",
  "ATTACHMENT_FILE": "ملف: $1",
  "ATTACHMENT_IMAGE": "صورة",
  "ATTACHMENT_TEXT": "نص: $1",
  "ATTACHMENT_VIDEO": "مقطع فيديو",
  "AVATAR_ALT": "أفاتار $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "التالي",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "السابق",
  "CITATION_MODEL_DIALOG_ALT": "الاقتباس",
  "CLOSE_BUTTON_ALT": "إغلاق",
  "COLLAPSIBLE_GROUPING_TITLE": "جارٍ التفكير...",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "يظهر هذا عندما يقوم الروبوت بإنشاء رسائل استجابة في مجموعة إذا لم يتم توفير أي ملخص.",
  "COLLAPSE_BUTTON_LESS": "عرض أقل",
  "COLLAPSE_BUTTON_LESS.comment": "هذا نص زر شارة لطي مجموعة من الرسائل. عندما ينقر المستخدم النهائي فوق الزر، تُطوى مجموعة الرسائل.",
  "COLLAPSE_BUTTON_MORE": "عرض المزيد",
  "COLLAPSE_BUTTON_MORE.comment": "هذا نص زر شارة لتوسيع مجموعة من الرسائل. عندما ينقر المستخدم النهائي فوق الزر، تتوسع مجموعة الرسائل.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "متصل",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "جارٍ الاتصال…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "يتعذر الاتصال.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "حدث انقطاع في الشبكة. جارٍ إعادة الاتصال…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "خطأ في العرض. الرجاء فحص وحدة التحكم أو الاتصال بمطور الروبوت.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "يستغرق وقتًا أطول من المعتاد للاتصال.",
  "CONNECTIVITY_STATUS_ALT": "حالة الاتصال: $1",
  "COPY_BUTTON_TEXT": "نسخ",
  "COPY_BUTTON_COPIED_TEXT": "تم النسخ",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "‏‏إرسال‬",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "‏‏إلغاء‬",
  "FEEDBACK_FORM_PLACEHOLDER": "قدم أكبر قدر ممكن من التفاصيل، ولكن لا تضمن أي معلومات خاصة أو حساسة.",
  "FEEDBACK_FORM_TITLE": "‏‫أخبرنا عن تجربتك‬",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "تنزيل ملف '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "تنزيل الملف '$1' بحجم $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1' بحجم $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "فتح في نافذة جديدة؛ خارجية.",
  "RECEIPT_CARD_TAX": "الضريبة",
  "RECEIPT_CARD_TOTAL": "الإجمالي‬",
  "RECEIPT_CARD_VAT": "ضريبة القيمة المضافة",
  "REFERENCE_LIST_HEADER_ONE": "$1 مرجع",
  "REFERENCE_LIST_HEADER_FEW": "$1 مراجع",
  "REFERENCE_LIST_HEADER_MANY": "$1 مراجع",
  "REFERENCE_LIST_HEADER_OTHER": "$1 مراجع",
  "REFERENCE_LIST_HEADER_TWO": "مراجع $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "حذف المرفق $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "حذف",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "ملف",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "صورة",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "لا يمكن إرسال رسالة فارغة.",
  "SPEECH_INPUT_LISTENING": "جارٍ الاستماع…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "الميكروفون متوقف عن التشغيل",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "الميكروفون قيد التشغيل",
  "SPEECH_INPUT_STARTING": "البدء…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "التالي",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "السابق",
  "SUGGESTED_ACTIONS_LABEL_ALT": "الإجراءات المقترحة",
  "TEXT_INPUT_ALT": "مربع إدخال الرسالة",
  "TEXT_INPUT_PLACEHOLDER": "اكتب رسالتك",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "ابدأ التحدث...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "جارٍ الاستماع...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "جارٍ المعالجة...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "تحدّث للمقاطعة...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "‏‏إرسال",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "تحدّث",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "تحميل الملف",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "لوحة مفاتيح الهاتف",
  "TEXT_INPUT_DROP_ZONE": "إسقاط الملفات",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "تم تجاوز طول الرسالة",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "يدعم إدخال من رقم واحد فقط",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 من المرفقات",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 من المرفقات",
  "TEXT_INPUT_ATTACHMENTS_ONE": "‏‏مرفق واحد‬",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 من المرفقات",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 مرفقان",
  "TOAST_ACCORDION_FEW": "$1 إعلامات: انقر هنا للاطلاع على التفاصيل",
  "TOAST_ACCORDION_MANY": "$1 إعلامات: انقر هنا للاطلاع على التفاصيل",
  "TOAST_ACCORDION_OTHER": "$1 إعلامات: انقر هنا للاطلاع على التفاصيل",
  "TOAST_ACCORDION_TWO": "$1 إعلامات: انقر هنا للاطلاع على التفاصيل",
  "TOAST_ALT_ERROR": "‏‏الخطأ",
  "TOAST_ALT_INFO": "المعلومات",
  "TOAST_ALT_SUCCESS": "نجاح",
  "TOAST_ALT_WARN": "تحذير",
  "TOAST_DISMISS_BUTTON": "رفض",
  "TOAST_TITLE_ALT": "الإعلام",
  "TRANSCRIPT_ARIA_LABEL_ALT": "محفوظات الدردشة، اضغط على مفاتيح الأسهم للتنقل.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "محفوظات الدردشة",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "الرسالة تفاعلية. اضغط على مفتاح shift tab من مرتين إلى 3 مرات للتبديل إلى محفوظات الدردشة. ثم انقر فوق الرسالة للتفاعل.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "هناك ارتباط أو أكثر في الرسالة. اضغط على مفتاح shift tab من مرتين إلى 3 مرات للتبديل إلى محفوظات الدردشة. ثم انقر فوق الرسالة للتفاعل.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "تتضمن الرسالة إجراءات مقترحة. اضغط على shift tab من مرتين إلى 3 مرات لتحديدها.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "تتضمن الرسالة إجراءات مقترحة. اضغط على $1 لتحديدها.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "فشل إرسال الرسالة.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "هناك رسائل جديدة متوفرة. اضغط على $1 للتركيز على الزر \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "المزيد من الرسائل",
  "TRANSCRIPT_NEW_MESSAGES": "رسائل جديدة",
  "TRANSCRIPT_TERMINATOR_TEXT": "نهاية محفوظات الدردشة",
  "TYPING_INDICATOR_ALT": "إظهار مؤشر الكتابة",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 يكتب الآن.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 وغيره يكتبون الآن.",
  "VIEW_CODE_BUTTON_TEXT": "تعليمات برمجية",
  "VOTE_COMPLETE_ALT": "التعليقات المسجّلة",
  "VOTE_COMPLETE_ALT.comment": "يتعلق هذا الخيار بقارئ الشاشة. تسمية زر مع أيقونتي الإبهام لأعلى/لأسفل. يتم استخدام التسمية عند تسجيل التعليقات.",
  "VOTE_DISLIKE_ALT": "لم يعجبني",
  "VOTE_LIKE_ALT": "أعجبني"
}